module.exports = __webpack_public_path__ + "static/media/inbox.d4b34a31.svg";